import LoadingState from '../../../ReusableComponents/LoadingState';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { MdEvent, MdEventAvailable } from 'react-icons/md';
import moment from 'moment';
import { logout } from '../../../../actions/AppActions';
import Request from '../../../../Request';
import SectionButtons from '../../../ReusableComponents/SectionButtons';
import SectionContentHeading from '../../../ReusableComponents/SectionContentHeading';
import StatusBadge from '../../../ReusableComponents/StatusBadge';
import TextReadMore from '../../../ReusableComponents/TextReadMore';
import CorrectionReport from '../../../CorrectionReports/CorrectionReport';
import LogsDash from './LogsDash';
import CandidateAttendanceReport from './CandidateAttendanceReport';
import SalasOnline from './SalasOnline';
import CandidatosSaidas from '../../../CandidatosVinculados/CandidatosSaidas';
import AnalisesCandidatos from '../../../AnalisesCandidatos/AnalisesCandidatos';
import AnalisesMovimentoFacial from '../../../AnalisesMovimentoFacial/AnalisesMovimentoFacial';
import CandidatosConfiabilidade from '../../../CandidatosVinculados/CandidatosConfiabilidade';
import VideoAIEvents from '../../../CandidatosVinculados/VideoAIEvents';

const sections = [
    { value: 0, label: 'Logs gerais', icon: 'logs', description: 'Confira os totais, acessos e etapas percorridas pelos candidatos.' },
    { value: 1, label: 'Candidatos/Avaliadores online', icon: 'candidatos', description: 'Acompanhe os participantes conectados em cada sala.' },
    { value: 2, label: 'Saídas de tela', icon: 'telas', description: 'Consulte as ocorrências de saída da tela de avaliação.' },
    { value: 3, label: 'Análises faciais', icon: 'imagens', description: 'Revise as imagens e os resultados de reconhecimento facial.' },
    { value: 4, label: 'Análises de movimento facial', icon: 'videos', description: 'Consulte as verificações de movimento e presença do candidato.' },
    { value: 5, label: 'Confiabilidade', icon: 'fiscais', description: 'Confira os indicadores de confiabilidade da avaliação.' },
    { value: 6, label: 'Eventos IA', icon: 'ia', description: 'Revise os eventos identificados pela inteligência artificial.' },
    { value: 8, label: 'Correções de redação e dissertativas', icon: 'redacoes', description: 'Consulte correções de IA ou corretores e exporte as planilhas.' },
    { value: 7, label: 'Presentes e ausentes', icon: 'candidatos', description: 'Consulte a presença dos candidatos e baixe a planilha.' }
];

const ProcessDashboard = props => {
    const [loading, setLoading] = useState(true);
    const [processo, setProcesso] = useState({});
    const [selectTab, setSelectTab] = useState(0);
    const dispatch = useDispatch();

    useEffect(() => {
        let mounted = true;
        const get_processo = async () => {
            setLoading(true);
            const response = await Request.Get(`faculdade/dashboard/processo/${props.processo_id}`);
            if (!mounted || response === undefined) return;
            if (response.message === 'Unauthenticated.') {
                dispatch(logout());
                return;
            }
            setProcesso(response.processo[0]);
            setLoading(false);
        };
        get_processo();
        return () => { mounted = false; };
    }, [dispatch, props.processo_id]);

    if (loading) return <LoadingState title="Carregando relatórios do processo" />;

    const now = moment();
    const finished = now.isSameOrAfter(moment(processo.fim));
    const started = now.isSameOrAfter(moment(processo.inicio));

    return (
        <div className="dashboard-process">
            {processo.descricao && <TextReadMore title="Descrição: " element="div" limit={1000} style={{ marginBottom: 16, whiteSpace: 'pre-wrap' }}>
                {processo.descricao}
            </TextReadMore>}
            <div className="dashboard-process-meta">
                <span><MdEvent aria-hidden="true" /><span><small>Início</small><strong>{moment(processo.inicio).format('DD/MM/YYYY HH:mm')}</strong></span></span>
                <span><MdEventAvailable aria-hidden="true" /><span><small>Encerramento</small><strong>{moment(processo.fim).format('DD/MM/YYYY HH:mm')}</strong></span></span>
                <StatusBadge variant={finished ? 'danger' : started ? 'success' : 'warning'}>{finished ? 'Finalizado' : started ? 'Em andamento' : 'Não iniciado'}</StatusBadge>
            </div>

            <div className="dashboard-report-picker dashboard-process-reports hidethis">
                <h3>Escolha o relatório para visualizar</h3>
                <SectionButtons compact variant="modules" label="Relatórios da avaliação" value={selectTab} items={sections} onChange={setSelectTab} />
            </div>
            <div className="dashboard-selected-report">
                <SectionContentHeading items={sections} value={selectTab} />
                {selectTab === 0 && <LogsDash processo={processo} />}
                {selectTab === 1 && <SalasOnline processo={processo} />}
                {selectTab === 2 && <CandidatosSaidas processo_id={processo.id} processo_name={processo.name} />}
                {selectTab === 3 && <AnalisesCandidatos processo_id={processo.id} processo_name={processo.name} />}
                {selectTab === 4 && <AnalisesMovimentoFacial processo_id={processo.id} processo_name={processo.name} />}
                {selectTab === 5 && <CandidatosConfiabilidade processo_id={processo.id} processo_name={processo.name} />}
                {selectTab === 6 && <VideoAIEvents processo_id={processo.id} />}
                {selectTab === 8 && <CorrectionReport key={processo.id} faculdade_id={props.faculdade_id} processo_id={processo.id} />}
                {selectTab === 7 && <CandidateAttendanceReport faculdade_id={props.faculdade_id} processo_id={processo.id} />}
            </div>
        </div>
    );
};

export default ProcessDashboard;
